"use client"

import { ReactNode, useEffect, useLayoutEffect, useRef } from "react"

interface RenderingTimeProps {
  children: ReactNode
  componentName: string
  dependencies?: readonly unknown[]
  onlyFirst?: boolean
}

const getTimeName = (time: number) => {
  if (time >= 0 && time <= 5) {
    return "Rapid"
  } else if (time > 5 && time <= 20) {
    return "Fast"
  } else if (time > 20 && time <= 100) {
    return "Slow"
  }

  return "Extremely slow"
}

const timeColors = {
  Rapid: "lime",
  Fast: "green",
  Slow: "yellow",
  "Extremely slow": "red",
}

export const RenderingTime = ({
  children,
  componentName,
  dependencies = [],
  onlyFirst = false,
}: RenderingTimeProps) => {
  const startRef = useRef(performance.now())
  const endRef = useRef(performance.now())
  const firstRender = useRef(true)

  useLayoutEffect(() => {
    startRef.current = performance.now()
  }, [dependencies])

  useEffect(() => {
    endRef.current = performance.now()

    if (onlyFirst && !firstRender.current) {
      return
    }
    const duration = endRef.current - startRef.current
    const timeName = getTimeName(duration)

    // biome-ignore lint/suspicious/noConsole lint/suspicious/noConsoleLog: log added for measuring performance
    console.log(
      `%cRendering time: ${endRef.current - startRef.current} ms. (${timeName})` +
        `%cComponent name: ${componentName}${firstRender.current ? "(First render)" : ""}`,
      `background: ${timeColors[timeName]}; color: black;`,
      "border-bottom: 1px solid;",
    )
  }, [dependencies])

  useEffect(() => {
    firstRender.current = false
  }, [])

  return children
}
